// Campos da tabela de produtos (compartilhado entre pedidos e sacolas)
export interface LayoutTabelaProdutos {
  produtoImagem: boolean;
  produtoReferencia: boolean;
  produtoPeso: boolean;
  produtoNome: boolean;
  produtoDescricao: boolean;
  produtoVariacao: boolean;
  produtoQuantidade: boolean;
  produtoPreco: boolean;
  produtoTotal: boolean;
  produtoObservacao: boolean;
  // Footer
  footerUltimaPeca: boolean;
  footerPesoTotal: boolean;
  footerTotalProdutos: boolean;
  footerValorProdutos: boolean;
}

export interface LayoutImpressaoPedido {
  // Campos do pedido
  numeroPedido: boolean;
  dataPedido: boolean;
  catalogo: boolean;
  vendedor: boolean;
  telefone: boolean;
  email: boolean;
  dataNascimento: boolean;
  cpf: boolean;
  cnpj: boolean;
  inscricaoEstadual: boolean;
  endereco: boolean;
  valorTotal: boolean;
  descontoProgressivo: boolean;
  descontoPix: boolean;
  descontoCupom: boolean;
  frete: boolean;
  pagamento: boolean;
  observacaoInterna: boolean;
  observacaoCliente: boolean;
  // Campos da tabela de produtos
  tabelaProdutos: LayoutTabelaProdutos;
}

export interface LayoutImpressaoSacola {
  // Campos da sacola
  numeroSacola: boolean;
  data: boolean;
  catalogo: boolean;
  vendedor: boolean;
  telefone: boolean;
  email: boolean;
  dataNascimento: boolean;
  cpf: boolean;
  cnpj: boolean;
  inscricaoEstadual: boolean;
  endereco: boolean;
  valorTotal: boolean;
  descontoProgressivo: boolean;
  observacaoCliente: boolean;
  // Campos da tabela de produtos
  tabelaProdutos: LayoutTabelaProdutos;
}

// Default para tabela de produtos
export const defaultLayoutTabelaProdutos: LayoutTabelaProdutos = {
  produtoImagem: true,
  produtoReferencia: true,
  produtoPeso: true,
  produtoNome: true,
  produtoDescricao: true,
  produtoVariacao: true,
  produtoQuantidade: true,
  produtoPreco: true,
  produtoTotal: true,
  produtoObservacao: true,
  footerUltimaPeca: true,
  footerPesoTotal: true,
  footerTotalProdutos: true,
  footerValorProdutos: true,
};

// Defaults (todos true)
export const defaultLayoutPedido: LayoutImpressaoPedido = {
  numeroPedido: true,
  dataPedido: true,
  catalogo: true,
  vendedor: true,
  telefone: true,
  email: true,
  dataNascimento: true,
  cpf: true,
  cnpj: true,
  inscricaoEstadual: true,
  endereco: true,
  valorTotal: true,
  descontoProgressivo: true,
  descontoPix: true,
  descontoCupom: true,
  frete: true,
  pagamento: true,
  observacaoInterna: true,
  observacaoCliente: true,
  tabelaProdutos: defaultLayoutTabelaProdutos,
};

export const defaultLayoutSacola: LayoutImpressaoSacola = {
  numeroSacola: true,
  data: true,
  catalogo: true,
  vendedor: true,
  telefone: true,
  email: true,
  dataNascimento: true,
  cpf: true,
  cnpj: true,
  inscricaoEstadual: true,
  endereco: true,
  valorTotal: true,
  descontoProgressivo: true,
  observacaoCliente: true,
  tabelaProdutos: defaultLayoutTabelaProdutos,
};

// Labels para exibição no modal de configuração
export const labelsCamposPedido: Record<keyof Omit<LayoutImpressaoPedido, 'tabelaProdutos'>, string> = {
  numeroPedido: "Número do pedido",
  dataPedido: "Data do pedido",
  catalogo: "Catálogo",
  vendedor: "Vendedor",
  telefone: "Telefone",
  email: "E-mail",
  dataNascimento: "Data de nascimento",
  cpf: "CPF",
  cnpj: "CNPJ",
  inscricaoEstadual: "Inscrição Estadual",
  endereco: "Endereço",
  valorTotal: "Valor total",
  descontoProgressivo: "Desconto progressivo",
  descontoPix: "Desconto PIX",
  descontoCupom: "Desconto cupom",
  frete: "Frete",
  pagamento: "Pagamento",
  observacaoInterna: "Observação interna",
  observacaoCliente: "Observação do cliente",
};

export const labelsCamposSacola: Record<keyof Omit<LayoutImpressaoSacola, 'tabelaProdutos'>, string> = {
  numeroSacola: "Número da sacola",
  data: "Data",
  catalogo: "Catálogo",
  vendedor: "Vendedor",
  telefone: "Telefone",
  email: "E-mail",
  dataNascimento: "Data de nascimento",
  cpf: "CPF",
  cnpj: "CNPJ",
  inscricaoEstadual: "Inscrição Estadual",
  endereco: "Endereço",
  valorTotal: "Valor total",
  descontoProgressivo: "Desconto progressivo",
  observacaoCliente: "Observação do cliente",
};

export const labelsCamposTabelaProdutos: Record<keyof LayoutTabelaProdutos, string> = {
  produtoImagem: "Imagem do produto",
  produtoReferencia: "Referência",
  produtoPeso: "Peso",
  produtoNome: "Nome",
  produtoDescricao: "Descrição",
  produtoVariacao: "Variação",
  produtoQuantidade: "Quantidade",
  produtoPreco: "Preço unitário",
  produtoTotal: "Total",
  produtoObservacao: "Observação da variação",
  footerUltimaPeca: "Última peça disponível",
  footerPesoTotal: "Peso total",
  footerTotalProdutos: "Total de produtos",
  footerValorProdutos: "Valor dos produtos",
};
